module.exports = __webpack_public_path__ + "img/profilepic.12e0e916.jpeg";